import { render, staticRenderFns } from "./BankSlip.vue?vue&type=template&id=618b9b78&scoped=true&lang=pug"
import script from "./BankSlip.vue?vue&type=script&lang=js"
export * from "./BankSlip.vue?vue&type=script&lang=js"
import style0 from "./BankSlip.vue?vue&type=style&index=0&id=618b9b78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "618b9b78",
  null
  
)

export default component.exports